<template>
  <Fragment>
    <tr class="transparent-hover">
      <td rowspan="2" colspan="3" :class="`px-1 pr-3 ${borderClass}`">
        <div>
          <px-detalhes-produto v-if="produto.cotacaoProduto"
                               small
                               :produto="produto.cotacaoProduto"
                               show-obs-externa/>
          <px-span-tooltip v-if="checkCodigo(produto.cotacaoProduto.produto)"
                           top
                           :text="labelCodigo(produto.cotacaoProduto.produto)"
                           tooltip="Código do item"/>
          <px-span-tooltip top
                           :text="labelDescricao(produto)"
                           :tooltip="produto.cotacaoProduto.produto.descricao"/>
        </div>
        <div class="mb-3 ml-3 grey--text caption">
          <px-span-tooltip bottom
                           :text="codigoFornecedor(produto)"
                           tooltip="Código de referência do fornecedor"/>
        </div>
      </td>
      <td class="px-1 pt-2 d-flex no-border-fixed-height">
        <px-input-currency dense
                           label="Preço unitário"
                           class="rounded-tag-small"
                           hide-details
                           :options="configuracaoMoeda"
                           :precision="produto.cotacaoProduto.produto.casasDecimais"
                           :error="$v.produto.precoUnitario.$error"
                           @blur="$v.produto.precoUnitario.$touch()"
                           v-model="produto.precoUnitario"/>
        <px-input-percentual dense
                             show-suffix
                             input-class="rounded-tag-small ml-1 mr-1 width-percentual"
                             label="ICMS"
                             v-model="produto.icms"/>
        <px-input-percentual dense
                             show-suffix
                             input-class="rounded-tag-small width-percentual"
                             label="IPI"
                             v-model="produto.ipi"/>
        <div>
          <px-anexo badge-color="secondary"
                  :max="3"
                  :upload-base-path="uploadFilePath"
                  :download-base-path="downloadFilePath"
                  @loading="onFileLoad"
                  v-model="produto.arquivos"/>
        </div>
      </td>
    </tr>
    <tr class="transparent-hover">
      <td class="px-1" colspan="3" width="60%">
        <v-textarea label="Especificação"
                    hide-label
                    class="mb-2 mr-1 rounded-tag-small"
                    rows="1"
                    dense
                    outlined
                    hide-details
                    auto-grow
                    v-model="produto.especificacaoProduto"/>
      </td>
    </tr>
  </Fragment>
</template>
<script>
import Vue from 'vue';
import { Fragment } from 'vue-frag';
import { validationMixin } from 'vuelidate';
import moedaMixin from '@/mixins/moeda-mixin';

export default {
  mixins: [validationMixin, moedaMixin],
  props: {
    produto: {
      type: Object,
      required: true,
    },
    moeda: String,
    showDivider: Boolean,
    downloadFilePath: String,
    uploadFilePath: String,
  },
  data() {
    return {
      loading: false,
      hasFileLoading: false,
    };
  },
  computed: {
    checkCodigo() {
      return (item) => item.codigo;
    },
    labelCodigo() {
      return (item) => `${item.codigo} -`;
    },
    labelDescricao() {
      return (produto) => Vue.filter('truncate')(produto.cotacaoProduto.produto.descricao, 30);
    },
    borderClass() {
      return this.showDivider ? '' : 'no-border';
    },
    codigoFornecedor() {
      return (produto) => produto.cotacaoProduto.produto.codigoFornecedor;
    },
  },
  methods: {
    onFileLoad(loading) {
      this.hasFileLoading = loading;
    },
  },
  validations: {
    produto: {
      precoUnitario: {
        minValue(value) {
          return value > 0;
        },
      },
    },
  },
  components: {
    Fragment,
  },
};
</script>
<style scoped>
.no-border {
  border-bottom: none !important;
}

.no-border-fixed-height {
  border-bottom: none !important;
  height: 60px;
}

.width-percentual {
  max-width: 20%;
}

</style>
